"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("ys-table-layout", {
    attrs: {
      "table-wrapper-class": _vm.tableWrapperClass
    },
    scopedSlots: _vm._u([{
      key: "table",
      fn: function () {
        return [_c("ys-table", {
          ref: "tableRef",
          attrs: {
            "show-reload": "",
            immediate: "",
            ellipsis: "",
            columns: _vm.columns,
            method: _vm.getExportList,
            "table-props": _vm.tableProps
          },
          scopedSlots: _vm._u([{
            key: "toolbar",
            fn: function () {
              return [_vm._t("export", function () {
                return [_c("a-button", {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.handleExport
                  }
                }, [_vm._v("导出")])];
              })];
            },
            proxy: true
          }, {
            key: "operation",
            fn: function ({
              record
            }) {
              return [record.status === _vm.EXPORT_TASK_STATUS.COMPLETED ? _c("a-button", {
                attrs: {
                  type: "link"
                },
                on: {
                  click: function ($event) {
                    return _vm.handleDownload(record);
                  }
                }
              }, [_vm._v(" 下载 ")]) : _vm._e(), record.status === _vm.EXPORT_TASK_STATUS.PROCESSING ? _c("a-popconfirm", {
                attrs: {
                  title: "是否确认停止该导出任务？"
                },
                on: {
                  confirm: function ($event) {
                    return _vm.handleStop(record.id);
                  }
                }
              }, [_c("a-button", {
                attrs: {
                  type: "link"
                }
              }, [_vm._v(" 停止 ")])], 1) : _vm._e()];
            }
          }], null, true)
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;